export default "__VITE_ASSET__CTwMBqbu__"